//  @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import { injectIntl } from 'react-intl';

// Components
import AdditionalQuestions from './AdditionalQuestions';
import type { Props } from './AdditionalQuestions';

// Selectors
import {
  getParticipantComments,
  getCallBack,
  isDmsAppt
} from 'store/reducers/appointment/selectors';

// Actions
import { setCallBack } from 'store/reducers/appointment/actions';

const mapStateToProps = (state: State): $Shape<Props> => ({
  notes: getParticipantComments(state),
  callbackRequired: getCallBack(state),
  isDmsAppt: isDmsAppt(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    { setCallBack }
  )
)(AdditionalQuestions);



// WEBPACK FOOTER //
// ./src/components/molecules/AdditionalQuestions/AdditionalQuestionsContainer.js